import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './core/components/home/home.component';
import { AroundMeComponent } from './core/components/around-me/around-me.component';
import { FullLayoutComponent } from './core/components/layouts/full-layout/full-layout.component'

const routes: Routes = [
  { 
    path: '', 
    component: FullLayoutComponent,
    children: [
      {
        path: '',
        component: HomeComponent
      },
      {
        path: 'around-me/:city/:category',
        component: AroundMeComponent
      }
    ] 
  },
  {path: '**', redirectTo: ''}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// /Users/jaswantsingh/Documents/GitHub/maps/src/app/app-routing.module.ts